/**
 * @generated SignedSource<<62466a7248d14b93dcdb69d1961e34b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_user" | "CartNav_user" | "DisplaySettingsModal_user" | "Notifications_user">;
  readonly " $fragmentType": "TopBar_user";
};
export type TopBar_user$key = {
  readonly " $data"?: TopBar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_user",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AccountNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CartNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Notifications_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DisplaySettingsModal_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ea672cb010b789530d052b95426a4519";

export default node;
